import sidebarOpen from '../assets/icons/sidebarOpen.svg';
import Shortcut from '../utils/Shortcut';
import { svgToIcon } from '../utils/svg';
import Tool, {
  simpleToolButton,
  type IToolActionInput,
  type IToolEnabledInput,
} from './Tool';

class ToolPresent extends Tool {
  static toolName = 'Present';

  static action({ controller }: IToolActionInput) {
    controller.presentationController.actionStartPresenting();
  }

  static enabled({ controller }: IToolEnabledInput) {
    const { presentationController } = controller;
    return (
      presentationController.canPresent() &&
      !presentationController.isPresenting()
    );
  }

  static buttonComponent() {
    return simpleToolButton(ToolPresent, 'fa-regular fa-presentation-screen');
  }

  static hint(args: IToolEnabledInput) {
    return this.enabled(args)
      ? this.toolName
      : 'Add a frame around the content to present';
  }
}

abstract class PresentationControlTool extends Tool {
  static enabled({ controller }: IToolEnabledInput) {
    return controller.presentationController.isPresenting();
  }
}

class ToolExitPresentation extends PresentationControlTool {
  static toolName = 'Exit presentation';
  static shortcut = new Shortcut('escape');

  static action({ controller }: IToolActionInput) {
    controller.presentationController.actionStopPresenting();
  }

  static buttonComponent() {
    return simpleToolButton(ToolExitPresentation, 'fa-regular fa-xmark-large');
  }
}

class ToolNextSlide extends PresentationControlTool {
  static toolName = 'Next slide';
  static shortcut = new Shortcut('right,down');

  static action({ controller }: IToolActionInput) {
    controller.presentationController.actionNavigate('next');
  }

  static buttonComponent() {
    return simpleToolButton(ToolNextSlide, 'fa-regular fa-angle-right');
  }
}

class ToolPreviousSlide extends PresentationControlTool {
  static toolName = 'Previous slide';
  static shortcut = new Shortcut('left,up');

  static action({ controller }: IToolActionInput) {
    controller.presentationController.actionNavigate('previous');
  }

  static buttonComponent() {
    return simpleToolButton(this, 'fa-regular fa-angle-left');
  }
}

class ToolPresentationFrames extends PresentationControlTool {
  static toolName = 'Frames';

  static action({ controller }: IToolActionInput) {
    controller.presentationController.actionToggleFrames();
  }

  static buttonComponent() {
    return simpleToolButton(this, svgToIcon(sidebarOpen));
  }
}

export {
  ToolPresent,
  ToolExitPresentation,
  ToolNextSlide,
  ToolPreviousSlide,
  ToolPresentationFrames,
};
